import { useEffect, useState } from "react";

type IconProps = {
  className?: string;
  fill?: string;
};

const CommissionIcon = ({ className, fill='#FF9800' }: IconProps) => {
  const [_class, setClass] = useState(className);

  useEffect(() => {
    let classStr = className || "";
    if (!classStr.includes("w-")) {
      classStr += " w-5";
    }
    if (!classStr.includes("h-")) {
      classStr += " h-5";
    }

    setClass(classStr);
  }, [className]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 20"
      strokeWidth="0"
      stroke={fill}
      className={_class}
    >
      <g clip-path="url(#clip0_177292_28775)">
        <path
          d="M10 0C4.48609 0 0 4.48594 0 10C0 15.5139 4.48609 20 10 20C15.5136 20 19.9991 15.5139 19.9991 10C19.9991 4.48594 15.5136 0 10 0ZM14.0964 14.8116C13.6403 15.4433 12.97 15.7812 12.1586 15.7812H12.1583C11.4998 15.7812 10.7661 15.5492 10.0366 15.1173C9.77266 14.9614 9.47359 14.88 9.14828 14.88C8.16438 14.88 7.23594 15.5992 7.22672 15.6064C7.08938 15.7156 6.91641 15.7755 6.74016 15.7755C6.54094 15.7755 6.35141 15.7006 6.20641 15.5647C5.92547 15.3016 5.87875 14.8625 6.09781 14.5466C7.29281 12.8258 7.36359 11.875 7.04219 10.7812H5.32547C4.89453 10.7812 4.54437 10.4309 4.54437 10C4.54437 9.56938 4.89453 9.21875 5.32547 9.21875H6.48031C6.32078 8.75 6.16359 8.10406 6.16359 7.36C6.16359 5.19531 7.92469 3.43563 10.0895 3.43563C12.2427 3.43563 13.9942 5.18719 13.9942 7.33938C13.9942 7.77 13.6438 8.12078 13.2133 8.12078C12.7823 8.12078 12.4322 7.77063 12.4322 7.34C12.4322 6.04906 11.3819 4.99906 10.0911 4.99906C8.78703 4.99906 7.72578 6.05656 7.72578 7.35984C7.72578 8.04625 7.90922 8.59359 8.13813 9.21859H10.0102C10.4409 9.21859 10.7913 9.56922 10.7913 9.99984C10.7913 10.4308 10.4409 10.7811 10.0102 10.7811H8.66094C8.85812 11.7186 8.80406 12.4758 8.48828 13.3673C9.33797 13.2169 10.1328 13.3534 10.8322 13.7677C11.115 13.9348 11.6619 14.2161 12.1494 14.2161C12.45 14.2161 12.6727 14.1102 12.8303 13.8923C12.9766 13.6897 13.2133 13.5691 13.4637 13.5691C13.6286 13.5691 13.7866 13.62 13.9208 13.7169C14.0898 13.8389 14.2013 14.0217 14.2345 14.2278C14.2675 14.4339 14.2184 14.6425 14.0964 14.8116Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_177292_28775">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CommissionIcon;
